export default __webpack_public_path__ + "static/ActivityCardHands-006c39aa9cd3f8e0b31d443d043b2d23.png";